import { DealerResponse } from 'services/dealer';
import { Conditional, Modal } from 'components/pcc-components';
import { useAssociatedDealerForms } from 'components/associated-dealers/hooks/use-associated-dealer-forms';
import { DealerSearchForm } from '../dealer-search-form/dealer-search-form';
import { SearchResultsForm } from '../search-results-form/search-results-form';
import { useAssociatedDealer } from 'components/associated-dealers/associated-dealer-context';

type AssociatedDealerWrapperProps = {
  isDealerUser: boolean;
  dealerUserResponse: DealerResponse;
  children: React.ReactNode;
};

export const AssociatedDealerWrapper = ({
  isDealerUser,
  dealerUserResponse,
  children
}: AssociatedDealerWrapperProps) => {
  const { associatedDealerModal, searchResultsModal, selectCustomerModal } =
    useAssociatedDealer();
  const { searchResultsForm, dealerSearchForm } = useAssociatedDealerForms();

  return (
    <Conditional
      test={isDealerUser}
      fallback={
        <Modal {...associatedDealerModal.modalProps} isActive size="md">
          {children}
        </Modal>
      }
    >
      <Modal {...associatedDealerModal.modalProps} isActive size="md">
        <DealerSearchForm
          dealerSearchForm={dealerSearchForm}
          dealerUserResponse={dealerUserResponse}
          isModal={true}
        />
      </Modal>
      <Modal {...searchResultsModal?.modalProps}>
        <SearchResultsForm
          searchResultsForm={searchResultsForm}
          dealerStoreId={dealerUserResponse?.storeId}
          isModal={true}
        />
      </Modal>
      <Conditional test={selectCustomerModal?.modalProps?.isActive}>
        <Modal {...selectCustomerModal?.modalProps}>{children}</Modal>
      </Conditional>
    </Conditional>
  );
};
